/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetEodImportLogDtoPurchaseInvoice } from './GetEodImportLogDtoPurchaseInvoice';
import {
    GetEodImportLogDtoPurchaseInvoiceFromJSON,
    GetEodImportLogDtoPurchaseInvoiceFromJSONTyped,
    GetEodImportLogDtoPurchaseInvoiceToJSON,
} from './GetEodImportLogDtoPurchaseInvoice';
import type { GetNumberingDtoCompany } from './GetNumberingDtoCompany';
import {
    GetNumberingDtoCompanyFromJSON,
    GetNumberingDtoCompanyFromJSONTyped,
    GetNumberingDtoCompanyToJSON,
} from './GetNumberingDtoCompany';

/**
 * 
 * @export
 * @interface GetEodImportLogDto
 */
export interface GetEodImportLogDto {
    /**
     * 
     * @type {string}
     * @memberof GetEodImportLogDto
     */
    id: string;
    /**
     * 
     * @type {GetNumberingDtoCompany}
     * @memberof GetEodImportLogDto
     */
    company?: GetNumberingDtoCompany | null;
    /**
     * 
     * @type {number}
     * @memberof GetEodImportLogDto
     */
    documentId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodImportLogDto
     */
    documentExternalNumber?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetEodImportLogDto
     */
    documentIssueDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodImportLogDto
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof GetEodImportLogDto
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetEodImportLogDto
     */
    creationTs: Date;
    /**
     * 
     * @type {GetEodImportLogDtoPurchaseInvoice}
     * @memberof GetEodImportLogDto
     */
    purchaseInvoice?: GetEodImportLogDtoPurchaseInvoice | null;
}

/**
 * Check if a given object implements the GetEodImportLogDto interface.
 */
export function instanceOfGetEodImportLogDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "reason" in value;
    isInstance = isInstance && "creationTs" in value;

    return isInstance;
}

export function GetEodImportLogDtoFromJSON(json: any): GetEodImportLogDto {
    return GetEodImportLogDtoFromJSONTyped(json, false);
}

export function GetEodImportLogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEodImportLogDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'company': !exists(json, 'company') ? undefined : GetNumberingDtoCompanyFromJSON(json['company']),
        'documentId': !exists(json, 'documentId') ? undefined : json['documentId'],
        'documentExternalNumber': !exists(json, 'documentExternalNumber') ? undefined : json['documentExternalNumber'],
        'documentIssueDate': !exists(json, 'documentIssueDate') ? undefined : (json['documentIssueDate'] === null ? null : new Date(json['documentIssueDate'])),
        'reason': json['reason'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'creationTs': (new Date(json['creationTs'])),
        'purchaseInvoice': !exists(json, 'purchaseInvoice') ? undefined : GetEodImportLogDtoPurchaseInvoiceFromJSON(json['purchaseInvoice']),
    };
}

export function GetEodImportLogDtoToJSON(value?: GetEodImportLogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'company': GetNumberingDtoCompanyToJSON(value.company),
        'documentId': value.documentId,
        'documentExternalNumber': value.documentExternalNumber,
        'documentIssueDate': value.documentIssueDate === undefined ? undefined : (value.documentIssueDate === null ? null : value.documentIssueDate.toISOString()),
        'reason': value.reason,
        'description': value.description,
        'creationTs': (value.creationTs.toISOString()),
        'purchaseInvoice': GetEodImportLogDtoPurchaseInvoiceToJSON(value.purchaseInvoice),
    };
}

